import { useEffect } from "react";

import { useMorphablePackGroup, useLoading, useRouter } from "hooks";
import { jjLogger } from "utils/logUtils";
import { trackTemplateView } from "tracking/google/analytics";

import View from "./components/View";

const MorphablePackGroup = () => {
  const {
    push404,
    query: { slug },
  } = useRouter();
  const { loadMorphablePackGroup, morphablePackGroup, clearMorphablePackGroup } = useMorphablePackGroup();
  const { func: loadMorphablePackWithLoader, isNotFinished: isMorphablePackGroupLoading } = useLoading(
    loadMorphablePackGroup,
  );

  useEffect(() => {
    let ignore = false;
    const loadPackGroup = async () => {
      try {
        const packGroup = await loadMorphablePackWithLoader(slug);
        trackTemplateView(packGroup);
      } catch (error) {
        jjLogger.logError(`MorphablePackGroup View: catch error ${error}`);
        push404();
      }
    };

    if (!ignore) loadPackGroup();

    return () => {
      ignore = true;
      clearMorphablePackGroup();
    };
  }, [slug]);

  return <View morphablePackGroup={morphablePackGroup} isMorphablePackGroupLoading={isMorphablePackGroupLoading} />;
};

export default MorphablePackGroup;
